import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Constant } from '../../Constants/constant';
import { TitleService } from 'src/app/shared/Services/title.service';
import { ErrormessageService } from '../../Services/errormessage.service';
import { LayoutService } from '../../Services/layout.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit{
  sidebarVisible = false;
  statusCode!: Number;
  message='';
  notPermission = Constant.HaveNotPermission;
  badRequest = Constant.BadRequest;
  serviceUnAvailable = Constant.ServiceUnAvailable;
  somethingWrong = Constant.SomethingWrong;
  notFound = Constant.NotFound;
  errorMessage: string = '';
  tokenExpire = Constant.TokenExpire;
  constructor(private activatedRoute:ActivatedRoute,
    private _titleService: TitleService,
    private layoutService: LayoutService,
    private errorMessageService: ErrormessageService,private router:Router){
    var newTitle = 'Error';
    this._titleService.setTitle(newTitle);

    this.activatedRoute.queryParams.subscribe((params) => {
      this.statusCode = Number(params['status']??498);
    });
  }

  ngOnInit(): void {
    this.errorMessageService.errorMessage$.subscribe(message => {
      this.errorMessage = message;
    });
    if(this.errorMessage != ""){
      this.message = this.errorMessage;
      this.layoutService.setShowHeader(false);
      this.layoutService.setShowFooter(false);
      this.layoutService.setShowSidebar(false);
    }
    else{
      this.getErrorMessage();
    }
  }

  getErrorMessage():string{
    switch (this.statusCode) {
      case 401:
      case 403:
        return this.message = this.notPermission
      case 400:
        return this.message = this.badRequest
      case 404:
        return this.message = this.notFound
      case 503:
        return this.message = this.serviceUnAvailable
      case 498:
        this.layoutService.setShowSidebar(false);
        return this.message = this.tokenExpire;
      case 0:
        return this.message = this.somethingWrong
      default:
       return this.message = this.somethingWrong
    }
  }

  redirectToHomePage(){
    this.router.navigate(['/']).then(()=>
      window.location.reload()
    );
  }
}
